module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/etrade.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/etrade.png
// module id = 1167
// module chunks = 0